<template>
<div class="chapter">
<div class="inner_page">
<p><a id="Page_3"></a></p><a id="Page_3">
<h2 class="h2" id="dedication"><strong><img alt="Image" src="images/f1.jpg"/> <em>Spring</em> <img alt="Image" src="images/f2.jpg"/></strong></h2>
</a><p class="centerq"><a id="Page_3"><strong><em>Near Springwater,<br/>Montana Territory, 1874</em></strong></a><a id="Page_4"></a></p><a id="Page_4">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?1adddf89